// Collection: filter chips, Sort and frames per row, all in the page (no reload; every collection fits one page).
const grid = document.querySelector("[data-product-grid]"); const count = document.querySelector("[data-count]"); const empty = document.querySelector("[data-empty]");
const group = (sel, fn) => { const els = [...document.querySelectorAll(sel)]; els.forEach((b) => b.addEventListener("click", () => { els.forEach((x) => { x.classList.toggle("is-active", x === b); x.setAttribute("aria-pressed", String(x === b)); }); fn(b); })); };
group("[data-facet]", (b) => {
  let shown = 0;
  grid.querySelectorAll("[data-product-card]").forEach((c) => { const ok = b.dataset.facet === "all" || c.dataset.facets.split(" ").includes(b.dataset.facet); c.hidden = !ok; shown += ok; });
  count.textContent = shown; empty.hidden = shown > 0;
});
// frames per row: the grid reads its count from data-cols (2 or 4)
group("[data-cols]", (b) => { grid.dataset.cols = b.dataset.cols; });
// sort by the cards' data-price; "Featured" puts the collection's own (manual) order back
const featured = [...grid.children];
document.querySelector("[data-sort]")?.addEventListener("change", (e) => {
  const v = e.target.value, price = (c) => Number(c.dataset.price) || 0;
  const order = v === "asc" ? [...featured].sort((a, b) => price(a) - price(b)) : v === "desc" ? [...featured].sort((a, b) => price(b) - price(a)) : featured;
  order.forEach((c) => grid.appendChild(c));
});
